import React, { Component } from 'react';

export class Navigation extends Component {
	render() {
		return (
			<nav id='menu' className='navbar navbar-default navbar-fixed-top'>
				<div className='container'>
					<div className='navbar-header'>
						<button
							type='button'
							className='navbar-toggle collapsed'
							data-toggle='collapse'
							data-target='#bs-example-navbar-collapse-1'
						>
							{' '}
							<span className='sr-only'>Navega </span>{' '}
							<span className='icon-bar'></span>{' '}
							<span className='icon-bar'></span>{' '}
							<span className='icon-bar'></span>{' '}
						</button>
						<a className='navbar-brand page-scroll' href='#page-top'>
							Cursos Contpaqi
						</a>{' '}
					</div>

					<div
						className='collapse navbar-collapse'
						id='bs-example-navbar-collapse-1'
					>
						<ul className='nav navbar-nav navbar-right'>
							<li>
								<a href='#features' className='page-scroll'>
									Valor del Curso
								</a>
							</li>
							<li>
								<a href='#about' className='page-scroll'>
									Es real
								</a>
							</li>
							<li>
								<a href='#portfolio2' className='page-scroll'>
									Cursos
								</a>
							</li>
							<li>
								<a href='#contactwithpayment' className='page-scroll'>
									Comprar
								</a>
							</li>
							<li>
								<a href='#services' className='page-scroll'>
									Servicios
								</a>
							</li>
							<li>
								<a href='#contact' className='page-scroll'>
									Contactar
								</a>
							</li>
						</ul>
					</div>
				</div>
			</nav>
		);
	}
}

export default Navigation;

/*
							<li>
								<a href='#testimonials' className='page-scroll'>
									Opiniones
								</a>
							</li>
							<li>
								<a href='#team' className='page-scroll'>
									Equipo
								</a>
							</li>
*/
